import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class UserDataService {
    _userData: any;
    isDataLoading = signal<boolean>(false);

    set userData(data: any) {
        this._userData = data;
    }
    get userData() {
        return this._userData;
    }
}
